import { useState, useEffect, useRef } from "react";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";

import { FormInput } from "../../components/forms/inputs";
import { SiteHeader } from "../../components/header/header";
import { SiteFooter } from "../../components/footer/footer";
import { AppAlert } from "../../components/utilities/alert";
import { UseAuthentication } from "../../services/authentication/authentication.context";
import { isNull } from "../../_helpers/isNull";

export const LoginPage = () => {

    const [showPassword, setShowPassword] = useState(false);
    const [userEmail, setUserEmail] = useState('');
    const [userPassword, setUserPassword] = useState('');
    const [onAlert, setOnAlert] = useState();

    const { loginUser, isAuthenticated } = UseAuthentication();

    const subBttn = useRef();

    const handleSubmit = async () => {
        if (isNull(userEmail) || isNull(userPassword)) {
            setOnAlert({
                caption: 'Invalid input!',
                message: 'Please provide a valid email and password!',
                accept: 'Ok',
                onAcept: () => setOnAlert(),
            });
            return;
        }

        try {
            const res = await loginUser(userEmail, userPassword);
            console.log(res);
            if (res?.error) {
                setOnAlert({
                    caption: 'Login Failed!',
                    message: res?.error,
                    accept: 'Ok',
                    onAcept: () => setOnAlert(),
                });
              return;
            }
            const accessToken = res?.token;
            window.location.href = "/admin";
        } catch (error) {
            console.log({error});
        }

    }

    // useEffect(() => {
    //     if (isAuthenticated === true)  window.location.href = "/admin";
    // }, [isAuthenticated])


    return (
        <div className="f-pg app-pg">
            <SiteHeader togglenavOpen={() => ''}/>
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    onAcept={onAlert.onAcept}
                    onReject={onAlert.onReject}
                    onClose={() => setOnAlert()}
                />
            )}
            <div className="lg-txt hd">WELCOME BACK</div>
            <div className="login-form-container form-container">
                <form
                    className="login-form app-form"
                    onSubmit={ async (e) => {
                        e.preventDefault();
                        await handleSubmit();
                    }}
                >
                    <FormInput
                        type={'email'}
                        value={userEmail}
                        onChange={(e) => {
                            e.preventDefault();
                            setUserEmail(e.target.value);
                        }}
                        required={true}
                        label={'Email e.g. email@example.com'}
                        name={'email'}
                    />
                    <FormInput
                        type={showPassword ? "text" : "password"}
                        formIcon={showPassword ? faEyeSlash : faEye}
                        toggleIcon={(e) => {
                            e.preventDefault();
                            setShowPassword((show) => !show)
                        }}
                        required={true}
                        label={"Password"}
                        name={"password"}
                        onChange={(e) => {
                            e.preventDefault();
                            setUserPassword(e.target.value);
                        }}
                        value={userPassword}
                    />
                    <div className="action-text forgot">
                        <a href="/sendMail" className="action-link">Forgotten password</a>
                    </div>
                    <button
                        className="form-button"
                        onClick={async () => {
                            await handleSubmit();
                        }}
                    >
                        Login
                    </button>
                    <div className="action text">
                        <span>Don't have an account?</span>
                        <a href="/register" className="action-link">Sign up</a>
                    </div>
                </form>
            </div>
        </div>
    )
}